import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ReportsHistoryService {
  UrlHistoryRegion:any[]=[];
  UrlHistoryPlant:any[]=[];
  UrlHistoryEventType:any[]=[];
  UrlHistoryResoType:any[]=[];
  UrlOrderVendor:any[]=[];
  UrlOrderStatus:any[]=[];

  constructor( private readonly http  : HttpClient) {}

  baseURL = environment.baseAPIURL;

  getHistoryReport(user: any, params: any) {
    this.UrlHistoryEventType=[];
    params.eventType.forEach((id) => {
       this.UrlHistoryEventType.push(id.label);
    });
    this.UrlHistoryPlant=[];
    params.plant.forEach((id) => {
      this.UrlHistoryPlant.push(id);
    });

    this.UrlHistoryResoType=[];
    params.resoType.forEach((id) => {
      this.UrlHistoryResoType.push(id.label);
    });

    this.UrlHistoryRegion=[];
    params.region.forEach((id) => {
       this.UrlHistoryRegion.push(id.label);
    });
    const HistoryResponseBody = {
      eventtype: this.UrlHistoryEventType,
      plant: this.UrlHistoryPlant,
      resolutionType: this.UrlHistoryResoType,
      region: this.UrlHistoryRegion,
      startDate: params.startDate,
      endDate: params.endDate,
    };
    const url: string = this.baseURL + `/aetReport/aetHistory`;
    const rb = { event: HistoryResponseBody, userReqDto: user };

    return this.http.post(url, rb, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }
}
